/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Assessment } from '../models/Assessment';
import type { PostAssessmentRequest } from '../models/PostAssessmentRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class AssessmentsService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Record a standalone assessment completion (AI coach diagnostic)
     * @returns Assessment Assessment recorded
     * @throws ApiError
     */
    public postAssessments({
        requestBody,
    }: {
        requestBody: PostAssessmentRequest,
    }): CancelablePromise<Assessment> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/assessments',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid assessment linkage`,
                401: `Unauthorized`,
                404: `Video not found`,
            },
        });
    }

    /**
     * Get standalone assessment completions for the current user
     * @returns Assessment List of assessment completions
     * @throws ApiError
     */
    public getAssessments(): CancelablePromise<Array<Assessment>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/assessments',
            errors: {
                401: `Unauthorized`,
            },
        });
    }

}
